import Svg, { Use, SvgProps, Defs, Path, G } from "react-native-svg"
import { useTheme } from "styled-rn"

export const LoginStartLogin = (props: SvgProps) => {
  const theme = useTheme()

  return (
    <Svg viewBox="0 0 355 365" {...props}>
      <Defs>
        <G id="LoginStartLogin-Layer14_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M239.7 120.85Q214 99.2 177.65 100.15 140.8 99.35 114.9 120.95 102.9 132 97.25 145.25 91.8 158 91.3 175.05 90.5 206.8 112.75 228.4 113.5 229.1 114.25 229.8 140.75 251.45 179 251.45 213.95 251.55 238.45 229.65 239.75 228.45 241 227.25 263.55 204.9 264.1 174.8 264.4 142.45 239.7 120.85M205.85 139.25Q208.3 141.7 208.55 145.4 208.75 149.1 206.6 151.8 204.45 154.6 201.15 154.75 197.9 154.95 195.45 152.45 193.05 150.05 192.8 146.3 192.6 142.65 194.75 139.9 196.9 137.2 200.2 137 203.4 136.85 205.85 139.25M213.2 176.2Q211.85 190.95 202.9 197.9 194.05 204.95 181.1 206.3 168.2 207.7 156.25 200.6 144.4 193.6 142 179.05 160.55 175.25 180.85 174.8 201.1 174.4 213.2 176.2M141.8 148.15Q141.6 144.5 143.75 141.75 145.9 139.05 149.2 138.85 152.4 138.7 154.85 141.1 157.3 143.55 157.55 147.25 157.75 150.95 155.6 153.65 153.45 156.45 150.15 156.6 146.9 156.8 144.45 154.3 142.05 151.9 141.8 148.15Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M143.75 141.75Q141.6 144.5 141.8 148.15 142.05 151.9 144.45 154.3 146.9 156.8 150.15 156.6 153.45 156.45 155.6 153.65 157.75 150.95 157.55 147.25 157.3 143.55 154.85 141.1 152.4 138.7 149.2 138.85 145.9 139.05 143.75 141.75M202.9 197.9Q211.85 190.95 213.2 176.2 201.1 174.4 180.85 174.8 160.55 175.25 142 179.05 144.4 193.6 156.25 200.6 168.2 207.7 181.1 206.3 194.05 204.95 202.9 197.9M208.55 145.4Q208.3 141.7 205.85 139.25 203.4 136.85 200.2 137 196.9 137.2 194.75 139.9 192.6 142.65 192.8 146.3 193.05 150.05 195.45 152.45 197.9 154.95 201.15 154.75 204.45 154.6 206.6 151.8 208.75 149.1 208.55 145.4Z"
          />
        </G>
        <G id="LoginStartLogin-Layer13_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M237.4 117.7Q210.75 97.2 174.5 99.7 137.65 100.5 112.7 123.2 101.2 134.75 96.15 148.25 91.25 161.2 91.5 178.25 92 208.35 112.9 228.5 114.05 229.65 115.3 230.75 116 231.35 116.75 232 144.2 252.5 182.4 250.85 217.3 249.45 240.85 226.45 242.75 224.55 244.5 222.6 243.6 222.05 242.65 221.55 243.6 222.05 244.5 222.6 264.85 199.8 264.1 170.55 263.6 156.2 258.3 144.3 257.55 142.55 256.65 140.85 250 127.85 237.4 117.7M205.05 141.45Q205.55 145.15 203.65 148 201.8 151 198.55 151.4 195.35 151.9 192.65 149.6 190.05 147.45 189.45 143.75 188.95 140.1 190.85 137.2 192.75 134.3 196 133.8 199.2 133.4 201.85 135.55 204.55 137.75 205.05 141.45M212.6 171.7Q212.55 186.5 204.3 194.25 196 202 183.3 204.5 170.5 206.95 158.05 200.95 145.6 195 141.9 180.7 160.05 175.3 180.25 173.15 200.4 171 212.6 171.7M140.2 143.5Q142.1 140.6 145.35 140.1 148.55 139.7 151.2 141.85 153.9 144.05 154.4 147.75 154.9 151.45 153 154.3 151.15 157.3 147.9 157.7 144.7 158.2 142 155.9 139.4 153.75 138.8 150.05 138.3 146.4 140.2 143.5Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M145.35 140.1Q142.1 140.6 140.2 143.5 138.3 146.4 138.8 150.05 139.4 153.75 142 155.9 144.7 158.2 147.9 157.7 151.15 157.3 153 154.3 154.9 151.45 154.4 147.75 153.9 144.05 151.2 141.85 148.55 139.7 145.35 140.1M204.3 194.25Q212.55 186.5 212.6 171.7 200.4 171 180.25 173.15 160.05 175.3 141.9 180.7 145.6 195 158.05 200.95 170.5 206.95 183.3 204.5 196 202 204.3 194.25M203.65 148Q205.55 145.15 205.05 141.45 204.55 137.75 201.85 135.55 199.2 133.4 196 133.8 192.75 134.3 190.85 137.2 188.95 140.1 189.45 143.75 190.05 147.45 192.65 149.6 195.35 151.9 198.55 151.4 201.8 151 203.65 148Z"
          />
        </G>
        <G id="LoginStartLogin-Layer12_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M255.25 133.3Q252.95 129.3 250.15 125.7 241.2 114.25 226.9 106.65 197 91.45 161.75 100.6 125.7 108.3 105.4 135.25 96.25 148.65 93.8 162.9 91.4 176.5 94.85 193.3 99.2 214.35 112.9 228.5 119.4 235.25 128.05 240.4 128.9 240.85 129.65 241.35 160.45 256.35 197.7 247.6 231.7 239.75 250.55 212.85 264.05 192.9 264.7 171.6 261.15 172.1 256.95 172.45 261.15 172.1 264.7 171.6 264.95 162.7 263 153.6 260.45 142.4 255.25 133.3M189.05 138.5Q186.4 140.4 182.95 139.5 179.65 138.7 177.5 135.7 175.4 132.7 175.8 129.25 176.15 125.8 178.9 123.95 181.5 122.05 184.95 122.85 188.3 123.65 190.4 126.7 192.5 129.7 192.05 133.15 191.75 136.6 189.05 138.5M178.25 168.4Q187.7 162.9 195.2 161.7 200.4 160.8 206.8 162.1 212.85 163.3 214.35 170.15 215.65 176.4 212.7 183.45 210.15 189.35 206.75 193.55 203.3 197.55 197.85 201.3 187.6 208.2 174.05 206.15 165.6 204.95 161.4 202.55 155.15 199 154.5 191.7 154 186.15 161.85 179.4 167.25 174.65 178.25 168.4M147.9 159.45Q147.55 162.95 144.85 164.8 142.15 166.65 138.75 165.85 135.45 165.05 133.3 161.95 131.15 158.95 131.6 155.55 132 152.05 134.7 150.15 137.35 148.4 140.75 149.15 144.15 149.95 146.25 152.95 148.3 156.05 147.9 159.45Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M144.85 164.8Q147.55 162.95 147.9 159.45 148.3 156.05 146.25 152.95 144.15 149.95 140.75 149.15 137.35 148.4 134.7 150.15 132 152.05 131.6 155.55 131.15 158.95 133.3 161.95 135.45 165.05 138.75 165.85 142.15 166.65 144.85 164.8M195.2 161.7Q187.7 162.9 178.25 168.4 167.25 174.65 161.85 179.4 154 186.15 154.5 191.7 155.15 199 161.4 202.55 165.6 204.95 174.05 206.15 187.6 208.2 197.85 201.3 203.3 197.55 206.75 193.55 210.15 189.35 212.7 183.45 215.65 176.4 214.35 170.15 212.85 163.3 206.8 162.1 200.4 160.8 195.2 161.7M182.95 139.5Q186.4 140.4 189.05 138.5 191.75 136.6 192.05 133.15 192.5 129.7 190.4 126.7 188.3 123.65 184.95 122.85 181.5 122.05 178.9 123.95 176.15 125.8 175.8 129.25 175.4 132.7 177.5 135.7 179.65 138.7 182.95 139.5Z"
          />
        </G>
        <G id="LoginStartLogin-Layer11_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M253.95 130.6Q251.9 126.9 249.55 123.6 245.9 118.5 241.4 114.3 230.8 104.3 215.55 98.9 183.6 88.5 150.2 102.9 115.75 115.95 99.8 145.65 92.8 160.4 92.5 174.75 92.2 188.6 98.15 204.7 102.25 215.65 108.75 224.15 110.1 222.85 111.5 221.4 110.1 222.85 108.75 224.15 110.5 226.5 112.5 228.65 122.8 239.95 138.1 246.2 139 246.5 139.85 246.9 172.55 257 208 242.75 240.45 229.75 255.05 200.35 269.65 169.55 258.3 139.9 256.35 135 253.95 130.6 252.2 131.45 250.25 132.25 252.2 131.45 253.95 130.6M170 135.35L175.3 123.05 170 135.35M164.5 186.45Q163.2 170.9 173.95 163.8 184.3 156.9 197.7 159.75 204.7 161.1 210.85 165.45 218.2 170.65 219.05 177.15 219.5 181.35 215.85 187.8 212.3 194 206.3 199.85 199.95 205.9 193.75 208.85 186.7 212.15 182 210.4 174.5 207.55 169.55 200.35 165.05 193.7 164.5 186.45M131.95 161L144.65 156.6 131.95 161Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M173.95 163.8Q163.2 170.9 164.5 186.45 165.05 193.7 169.55 200.35 174.5 207.55 182 210.4 186.7 212.15 193.75 208.85 199.95 205.9 206.3 199.85 212.3 194 215.85 187.8 219.5 181.35 219.05 177.15 218.2 170.65 210.85 165.45 204.7 161.1 197.7 159.75 184.3 156.9 173.95 163.8Z"
          />
        </G>
        <G id="LoginStartLogin-Layer10_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M245.95 119Q245.85 118.85 245.7 118.7 243.95 120.35 241.95 122 243.95 120.35 245.7 118.7 242.6 115.05 239 111.9 228.05 102.3 212.6 97.55 180.3 88.4 147.5 104.1 113.6 118.5 98.75 148.8 92.35 163.75 92.6 178.15 92.85 192.05 99.4 207.8 101.85 213.7 105.05 218.85 107.15 217.7 109.35 216.35 107.15 217.7 105.05 218.85 117.6 239.3 140.95 247.75 141.9 248.05 142.8 248.35 175.8 257.2 210.7 241.55 242.6 227.35 256 197.35 269.4 166 256.9 136.85 252.5 126.75 245.95 119M168.2 135.7L173 123.15 168.2 135.7M173.9 164.4Q183.75 157.05 197.1 160.15 204.25 161.7 210.7 166.45 218.5 172.2 219.55 179.2 220.15 183.85 216.55 190.7 213.1 197.25 207.25 203.25 201.1 209.4 195 212.25 188.25 215.35 183.55 213.3 176.25 210.05 171.15 202.45 166.6 195.45 165.75 187.9 163.8 171.75 173.9 164.4M131.05 162.65L143.55 157.75 131.05 162.65Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M197.1 160.15Q183.75 157.05 173.9 164.4 163.8 171.75 165.75 187.9 166.6 195.45 171.15 202.45 176.25 210.05 183.55 213.3 188.25 215.35 195 212.25 201.1 209.4 207.25 203.25 213.1 197.25 216.55 190.7 220.15 183.85 219.55 179.2 218.5 172.2 210.7 166.45 204.25 161.7 197.1 160.15Z"
          />
        </G>
        <G id="LoginStartLogin-Layer9_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M246.15 119.25Q246.05 119.1 245.95 119 242.75 115.15 239 111.9 228.05 102.3 212.6 97.55 180.3 88.4 147.5 104.1 113.6 118.5 98.75 148.8 92.35 163.75 92.6 178.15 92.85 192.05 99.4 207.8 102.1 214.25 105.65 219.85 108.2 218.05 110.85 215.85 108.2 218.05 105.65 219.85 118.15 239.5 140.95 247.75 141.9 248.05 142.8 248.35 175.8 257.2 210.7 241.55 242.6 227.35 256 197.35 269.4 166 256.9 136.85 252.55 126.9 246.15 119.25 243.6 121.4 240.45 123.5 243.6 121.4 246.15 119.25M167.95 135.9L173.9 123.9 167.95 135.9M174.75 165.35Q184.65 157.95 197.55 160.95 204.35 162.45 210.15 167.05 217.15 172.5 217.75 179.15 218.05 183.45 214.45 189.9 211.05 196.05 205.45 201.7 199.65 207.55 193.95 210.35 187.6 213.5 183.3 211.85 176.45 209.2 171.7 202.35 167.3 195.9 166.45 188.7 164.6 172.85 174.75 165.35M131.65 163.45L143.75 157.7 131.65 163.45Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M197.55 160.95Q184.65 157.95 174.75 165.35 164.6 172.85 166.45 188.7 167.3 195.9 171.7 202.35 176.45 209.2 183.3 211.85 187.6 213.5 193.95 210.35 199.65 207.55 205.45 201.7 211.05 196.05 214.45 189.9 218.05 183.45 217.75 179.15 217.15 172.5 210.15 167.05 204.35 162.45 197.55 160.95Z"
          />
        </G>
        <G id="LoginStartLogin-Layer8_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M258.15 139.65Q254.1 129.4 247.85 121.5 247.6 121.2 247.4 120.9 242.4 124.95 235 128.55 242.4 124.95 247.4 120.9 244.5 117.3 241.15 114.15 230.55 104.15 215.25 98.9 183.3 88.6 149.95 103.15 115.6 116.35 99.7 146.1 92.8 160.85 92.55 175.25 92.3 189.15 98.3 205.05 102.25 215.45 108.35 223.65 113.65 220.5 119.4 215.4 113.65 220.5 108.35 223.65 119.65 238.9 138.4 246.45 139.35 246.8 140.2 247.15 172.9 257.15 208.3 242.7 240.7 229.6 255.15 200.15 269.65 169.25 258.15 139.65M170.2 137.95L178.95 127.75 170.2 137.95M168.45 189.15Q166.65 174.85 176.35 167.85 185.65 161 197.3 163.65 203.2 164.95 208.2 168.9 213.9 173.4 214.25 179.1 214.4 182.75 211.25 188.25 208.25 193.55 203.3 198.6 198.25 203.8 193.25 206.6 187.65 209.65 183.8 208.45 177.6 206.7 173.3 200.95 169.2 195.55 168.45 189.15M135.2 164.9L146.95 158.35 135.2 164.9Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M176.35 167.85Q166.65 174.85 168.45 189.15 169.2 195.55 173.3 200.95 177.6 206.7 183.8 208.45 187.65 209.65 193.25 206.6 198.25 203.8 203.3 198.6 208.25 193.55 211.25 188.25 214.4 182.75 214.25 179.1 213.9 173.4 208.2 168.9 203.2 164.95 197.3 163.65 185.65 161 176.35 167.85Z"
          />
        </G>
        <G id="LoginStartLogin-Layer7_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M237 118.6Q210.5 98.2 174.5 100.7 137.85 101.5 113.1 124.05 101.6 135.5 96.6 148.9 91.75 161.85 91.95 178.75 92.5 211.35 117.1 232.15 144.35 252.5 182.3 250.85 217 249.45 240.4 226.65 264.25 202.7 263.5 171.1 262.4 139 237 118.6M193.05 187.25Q193.25 192.75 188.8 196.85 184.35 200.95 177.8 201.25 171.25 201.55 166.5 197.85 161.65 194.15 161.45 188.65 161.2 183.15 165.7 179 170.1 174.95 176.65 174.65 183.2 174.35 188 178 192.8 181.75 193.05 187.25M192.2 151L205.55 149.7 192.2 151M145.6 153.35L158.95 152.3 145.6 153.35Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M188.8 196.85Q193.25 192.75 193.05 187.25 192.8 181.75 188 178 183.2 174.35 176.65 174.65 170.1 174.95 165.7 179 161.2 183.15 161.45 188.65 161.65 194.15 166.5 197.85 171.25 201.55 177.8 201.25 184.35 200.95 188.8 196.85Z"
          />
        </G>
        <G id="LoginStartLogin-Layer6_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M239.75 120.85Q214.05 99.2 177.7 100.15 140.85 99.35 114.95 120.95 102.95 132 97.3 145.25 91.85 158 91.35 175.05 90.5 207.85 114.3 229.8 140.8 251.45 179.05 251.45 214 251.55 238.5 229.65 263.55 206.55 264.15 174.8 264.45 142.45 239.75 120.85M163.05 190.8Q163.05 184.9 167 180.7 170.95 176.55 176.55 176.55 182.15 176.55 186.1 180.7 190.05 184.9 190.05 190.8 190.05 196.7 186.1 200.85 182.15 205.05 176.55 205.05 170.95 205.05 167 200.85 163.05 196.7 163.05 190.8M194.1 149.8L207.5 149.2 194.1 149.8M146.55 150.6L159.95 150 146.55 150.6Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M167 180.7Q163.05 184.9 163.05 190.8 163.05 196.7 167 200.85 170.95 205.05 176.55 205.05 182.15 205.05 186.1 200.85 190.05 196.7 190.05 190.8 190.05 184.9 186.1 180.7 182.15 176.55 176.55 176.55 170.95 176.55 167 180.7Z"
          />
        </G>
        <G id="LoginStartLogin-Layer5_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M239.75 120.85Q214.05 99.2 177.7 100.15 140.85 99.35 114.95 120.95 102.95 132 97.3 145.25 91.85 158 91.35 175.05 90.5 207.85 114.3 229.8 140.8 251.45 179.05 251.45 214 251.55 238.5 229.65 263.55 206.55 264.15 174.8 264.45 142.45 239.75 120.85M164.05 190.8Q164.05 184.9 168 180.7 171.95 176.55 177.55 176.55 183.15 176.55 187.1 180.7 191.05 184.9 191.05 190.8 191.05 196.7 187.1 200.85 183.15 205.05 177.55 205.05 171.95 205.05 168 200.85 164.05 196.7 164.05 190.8M195.6 149.8L209 149.2 195.6 149.8M148.05 150.6L161.45 150 148.05 150.6Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M168 180.7Q164.05 184.9 164.05 190.8 164.05 196.7 168 200.85 171.95 205.05 177.55 205.05 183.15 205.05 187.1 200.85 191.05 196.7 191.05 190.8 191.05 184.9 187.1 180.7 183.15 176.55 177.55 176.55 171.95 176.55 168 180.7Z"
          />
        </G>
        <G id="LoginStartLogin-Layer4_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M239.2 121.35Q213.7 99.9 177.7 100.85 141.2 100.05 115.55 121.45 103.65 132.4 98.05 145.55 92.65 158.15 92.15 175.05 91.3 207.55 114.9 229.3 141.15 250.75 179.05 250.75 213.65 250.85 237.95 229.15 262.75 206.25 263.35 174.8 263.65 142.75 239.2 121.35M163.1 180.7Q167 176.6 172.55 176.6 178.1 176.6 182 180.7 185.95 184.85 185.95 190.7 185.95 196.55 182 200.65 178.1 204.85 172.55 204.85 167 204.85 163.1 200.65 159.2 196.55 159.2 190.7 159.2 184.85 163.1 180.7M187.45 150.05L200.8 149.45 187.45 150.05M140.35 150.85L153.7 150.25 140.35 150.85Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M172.55 176.6Q167 176.6 163.1 180.7 159.2 184.85 159.2 190.7 159.2 196.55 163.1 200.65 167 204.85 172.55 204.85 178.1 204.85 182 200.65 185.95 196.55 185.95 190.7 185.95 184.85 182 180.7 178.1 176.6 172.55 176.6Z"
          />
        </G>
        <G id="LoginStartLogin-Layer3_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M236.15 124.05Q211.95 103.65 177.7 104.55 143 103.8 118.6 124.15 107.3 134.55 101.95 147.05 96.85 159.05 96.35 175.1 95.55 206 118 226.65 142.95 247.05 178.95 247.05 211.9 247.15 234.95 226.5 258.55 204.75 259.1 174.85 259.4 144.4 236.15 124.05M105.9 150.5L118.45 151.65 105.9 150.5M123.9 180.5Q127.2 176.6 131.9 176.6 136.6 176.6 139.9 180.5 143.2 184.45 143.2 190 143.2 195.55 139.9 199.45 136.6 203.45 131.9 203.45 127.2 203.45 123.9 199.45 120.6 195.55 120.6 190 120.6 184.45 123.9 180.5M144.15 151.3L156.8 150.75 144.15 151.3Z"
          />
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M131.9 176.6Q127.2 176.6 123.9 180.5 120.6 184.45 120.6 190 120.6 195.55 123.9 199.45 127.2 203.45 131.9 203.45 136.6 203.45 139.9 199.45 143.2 195.55 143.2 190 143.2 184.45 139.9 180.5 136.6 176.6 131.9 176.6Z"
          />
        </G>
        <G id="LoginStartLogin-Layer2_0_FILL">
          <Path
            fill={theme.alwaysDark}
            stroke="none"
            d="M115.45 176.35Q115 176.35 114.55 176.4 114.45 187.4 118.25 196.7 120.15 195.95 121.65 194.1 124.25 191.1 124.25 186.75 124.25 182.45 121.65 179.4 119.1 176.35 115.45 176.35M117.3 157.8Q117.9 158.1 118.6 158.15L128.3 159.1Q129.7 159.2 130.75 158.3 131.75 157.45 131.9 156.1 132 154.75 131.15 153.7 130.25 152.65 128.9 152.55L119.75 151.65Q119.3 152.55 118.9 153.45 118.05 155.55 117.3 157.8Z"
          />
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M223.1 135.6Q204.3 119.75 177.75 120.45 150.8 119.85 131.85 135.65 123.85 143 119.75 151.65L128.9 152.55Q130.25 152.65 131.15 153.7 132 154.75 131.9 156.1 131.75 157.45 130.75 158.3 129.7 159.2 128.3 159.1L118.6 158.15Q117.9 158.1 117.3 157.8 114.85 165.55 114.55 175.25 114.55 175.85 114.55 176.4 115 176.35 115.45 176.35 119.1 176.35 121.65 179.4 124.25 182.45 124.25 186.75 124.25 191.1 121.65 194.1 120.15 195.95 118.25 196.7 122.4 207.05 131.35 215.3 150.75 231.15 178.7 231.15 204.3 231.2 222.2 215.2 240.55 198.3 240.95 175.05 241.2 151.4 223.1 135.6Z"
          />
        </G>
        <G id="LoginStartLogin-Layer1_0_FILL">
          <Path
            fill={theme.a_puzmo}
            stroke="none"
            d="M223.1 175.25Q223.25 158.3 210.3 147 196.8 135.6 177.75 136.1 158.4 135.7 144.85 147.05 138.55 152.85 135.6 159.8 132.7 166.45 132.45 175.4 132.45 175.8 132.45 176.25 132.4 184.1 135.1 190.8 138.05 198.2 144.5 204.1 158.4 215.45 178.45 215.45 196.8 215.5 209.65 204.05 222.75 191.9 223.1 175.25Z"
          />
        </G>
        <Path
          id="LoginStartLogin-Layer14_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M142 179.05Q160.55 175.25 180.85 174.8 201.1 174.4 213.2 176.2 211.85 190.95 202.9 197.9 194.05 204.95 181.1 206.3 168.2 207.7 156.25 200.6 144.4 193.6 142 179.05Z"
        />
        <Path
          id="LoginStartLogin-Layer14_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M241 227.25Q248.35 232.65 252.75 239.1 256.75 244.9 257.85 250.6 259.3 258.45 246.75 259.5 239.75 260.05 225.15 259.2M112.75 228.4Q106.4 233.35 102.45 239.1 98.45 244.9 97.35 250.6 95.9 258.45 108.45 259.5 115.45 260.05 130.05 259.2"
        />
        <Path
          id="LoginStartLogin-Layer13_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M141.9 180.7Q160.05 175.3 180.25 173.15 200.4 171 212.6 171.7 212.55 186.5 204.3 194.25 196 202 183.3 204.5 170.5 206.95 158.05 200.95 145.6 195 141.9 180.7Z"
        />
        <Path
          id="LoginStartLogin-Layer13_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M244.5 222.6Q251.65 226.9 256.4 232.3 261.05 237.6 262.8 243.1 265.15 250.75 252.8 253.25 245.95 254.65 231.35 255.5M112.9 228.5Q105.65 234.2 101 240.1 96.25 246.1 95.35 250.85 93.85 258.95 106.1 261.85 112.7 263.45 127.3 263.7M242.65 221.55Q243.6 222.05 244.5 222.6"
        />
        <Path
          id="LoginStartLogin-Layer12_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M264.7 171.6Q279.65 169.4 283.15 164.45 287.75 158.1 275.8 142.7M256.95 172.45Q261.15 172.1 264.7 171.6M112.9 228.5Q105.5 230.65 99.15 235.75 93 240.7 90.35 246.35 87.55 252.35 89.9 256.7 92.55 261.6 101.2 263.15"
        />
        <Path
          id="LoginStartLogin-Layer12_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M154.5 191.7Q154 186.15 161.85 179.4 167.25 174.65 178.25 168.4 187.7 162.9 195.2 161.7 200.4 160.8 206.8 162.1 212.85 163.3 214.35 170.15 215.65 176.4 212.7 183.45 210.15 189.35 206.75 193.55 203.3 197.55 197.85 201.3 187.6 208.2 174.05 206.15 165.6 204.95 161.4 202.55 155.15 199 154.5 191.7Z"
        />
        <Path
          id="LoginStartLogin-Layer11_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M170 135.35L175.3 123.05M182 210.4Q186.7 212.15 193.75 208.85 199.95 205.9 206.3 199.85 212.3 194 215.85 187.8 219.5 181.35 219.05 177.15 218.2 170.65 210.85 165.45 204.7 161.1 197.7 159.75 184.3 156.9 173.95 163.8 163.2 170.9 164.5 186.45 165.05 193.7 169.55 200.35 174.5 207.55 182 210.4ZM131.95 161L144.65 156.6"
        />
        <Path
          id="LoginStartLogin-Layer11_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M253.95 130.6Q267.6 124 271.45 114.55 276.1 103.5 269.85 80.7M250.25 132.25Q252.2 131.45 253.95 130.6M108.75 224.15Q97.95 234.3 87.7 236 76 237.9 56.85 228.9M111.5 221.4Q110.1 222.85 108.75 224.15"
        />
        <Path
          id="LoginStartLogin-Layer10_0_1_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M245.7 118.7Q257.1 108 258.2 97.75 259.2 88.25 250.95 67.6M105.05 218.85Q92.65 225.45 82.65 224.55 70.9 223.5 54.6 210M241.95 122Q243.95 120.35 245.7 118.7M109.35 216.35Q107.15 217.7 105.05 218.85"
        />
        <Path
          id="LoginStartLogin-Layer10_0_2_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M168.2 135.7L173 123.15M183.55 213.3Q188.25 215.35 195 212.25 201.1 209.4 207.25 203.25 213.1 197.25 216.55 190.7 220.15 183.85 219.55 179.2 218.5 172.2 210.7 166.45 204.25 161.7 197.1 160.15 183.75 157.05 173.9 164.4 163.8 171.75 165.75 187.9 166.6 195.45 171.15 202.45 176.25 210.05 183.55 213.3ZM131.05 162.65L143.55 157.75"
        />
        <Path
          id="LoginStartLogin-Layer9_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M167.95 135.9L173.9 123.9M183.3 211.85Q187.6 213.5 193.95 210.35 199.65 207.55 205.45 201.7 211.05 196.05 214.45 189.9 218.05 183.45 217.75 179.15 217.15 172.5 210.15 167.05 204.35 162.45 197.55 160.95 184.65 157.95 174.75 165.35 164.6 172.85 166.45 188.7 167.3 195.9 171.7 202.35 176.45 209.2 183.3 211.85ZM131.65 163.45L143.75 157.7"
        />
        <Path
          id="LoginStartLogin-Layer9_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M246.15 119.25Q256.05 110.95 257.75 101.95 260.1 90.2 249.45 69.1M105.65 219.85Q94.7 227.4 85.35 226.5 73.4 225.5 56.1 209.5M240.45 123.5Q243.6 121.4 246.15 119.25M110.85 215.85Q108.2 218.05 105.65 219.85"
        />
        <Path
          id="LoginStartLogin-Layer8_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M170.2 137.95L178.95 127.75M183.8 208.45Q187.65 209.65 193.25 206.6 198.25 203.8 203.3 198.6 208.25 193.55 211.25 188.25 214.4 182.75 214.25 179.1 213.9 173.4 208.2 168.9 203.2 164.95 197.3 163.65 185.65 161 176.35 167.85 166.65 174.85 168.45 189.15 169.2 195.55 173.3 200.95 177.6 206.7 183.8 208.45ZM135.2 164.9L146.95 158.35"
        />
        <Path
          id="LoginStartLogin-Layer8_0_2_STROKES"
          stroke={theme.a_puzmo}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M108.35 223.65Q100.6 228.2 93.7 228.6 81.95 229.3 64.65 209.05M247.4 120.9Q255.1 114.65 256.85 107.3 260.15 93.7 244 74.15M235 128.55Q242.4 124.95 247.4 120.9M119.4 215.4Q113.65 220.5 108.35 223.65"
        />
        <Path
          id="LoginStartLogin-Layer7_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M192.2 151L205.55 149.7M145.6 153.35L158.95 152.3"
        />
        <Path
          id="LoginStartLogin-Layer6_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M194.1 149.8L207.5 149.2M146.55 150.6L159.95 150"
        />
        <Path
          id="LoginStartLogin-Layer5_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M195.6 149.8L209 149.2M148.05 150.6L161.45 150"
        />
        <Path
          id="LoginStartLogin-Layer4_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M187.45 150.05L200.8 149.45M140.35 150.85L153.7 150.25"
        />
        <Path
          id="LoginStartLogin-Layer3_0_1_STROKES"
          stroke={theme.alwaysDark}
          strokeWidth="9"
          strokeLinejoin="round"
          strokeLinecap="round"
          fill="none"
          d="M105.9 150.5L118.45 151.65M144.15 151.3L156.8 150.75"
        />
      </Defs>
      <G id="LoginStartLogin-Scene-1t52" overflow="visible">
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer14_0_FILL" />
            <Use xlinkHref="#LoginStartLogin-Layer14_0_1_STROKES" />
            <Use xlinkHref="#LoginStartLogin-Layer14_0_2_STROKES" />
          </G>
          <animate attributeName="display" repeatCount="1" fill="freeze" dur="1.05s" keyTimes="0;.971;1" values="none;inline;inline" />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer13_0_FILL" />
            <Use xlinkHref="#LoginStartLogin-Layer13_0_1_STROKES" />
            <Use xlinkHref="#LoginStartLogin-Layer13_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05s"
            keyTimes="0;.914;.971;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer12_0_FILL" />
            <Use xlinkHref="#LoginStartLogin-Layer12_0_1_STROKES" />
            <Use xlinkHref="#LoginStartLogin-Layer12_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05s"
            keyTimes="0;.857;.914;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer11_0_FILL" />
            <Use xlinkHref="#LoginStartLogin-Layer11_0_1_STROKES" />
            <Use xlinkHref="#LoginStartLogin-Layer11_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05s"
            keyTimes="0;.8;.857;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer10_0_FILL" />
            <Use xlinkHref="#LoginStartLogin-Layer10_0_1_STROKES" />
            <Use xlinkHref="#LoginStartLogin-Layer10_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05s"
            keyTimes="0;.571;.8;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer9_0_FILL" />
            <Use xlinkHref="#LoginStartLogin-Layer9_0_1_STROKES" />
            <Use xlinkHref="#LoginStartLogin-Layer9_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05s"
            keyTimes="0;.514;.571;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer8_0_FILL" />
            <Use xlinkHref="#LoginStartLogin-Layer8_0_1_STROKES" />
            <Use xlinkHref="#LoginStartLogin-Layer8_0_2_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05s"
            keyTimes="0;.457;.514;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer7_0_FILL" />
            <Use xlinkHref="#LoginStartLogin-Layer7_0_1_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05s"
            keyTimes="0;.4;.457;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer6_0_FILL" />
            <Use xlinkHref="#LoginStartLogin-Layer6_0_1_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05s"
            keyTimes="0;.257;.4;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer5_0_FILL" />
            <Use xlinkHref="#LoginStartLogin-Layer5_0_1_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05s"
            keyTimes="0;.2;.257;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer4_0_FILL" />
            <Use xlinkHref="#LoginStartLogin-Layer4_0_1_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05s"
            keyTimes="0;.143;.2;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer3_0_FILL" />
            <Use xlinkHref="#LoginStartLogin-Layer3_0_1_STROKES" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05s"
            keyTimes="0;.086;.143;1"
            values="none;inline;none;none"
          />
        </G>
        <G display="none">
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer2_0_FILL" />
          </G>
          <animate
            attributeName="display"
            repeatCount="1"
            fill="freeze"
            dur="1.05s"
            keyTimes="0;.029;.086;1"
            values="none;inline;none;none"
          />
        </G>
        <G>
          <G>
            <Use xlinkHref="#LoginStartLogin-Layer1_0_FILL" />
          </G>
          <animate attributeName="display" repeatCount="1" fill="freeze" dur="1.05s" keyTimes="0;.029;1" values="inline;none;none" />
        </G>
      </G>
    </Svg>
  )
}
